const tooltipFormParamEquipModel = {
  title: 'clonar tipo de equipamento'
};

export default tooltipFormParamEquipModel;
